<template>
    <button class="dark-mode-toggle" @click="toggleDarkMode">
        <span v-if="theme === 'dark'">🌙</span>
        <span v-else>☀️</span>
        {{ theme === 'dark' ? '深色' : '浅色' }}
    </button>
</template>

<script>
export default {
    name: 'DarkModeToggle',
    data() {
        return {
            isDark: false,
        };
    },
    computed: {
        theme: {
            get() {
                return this.$store.state.theme
            },
            set(val) {
                this.$store.commit('set_theme', val)
            }
        }
    },

    created() {
        this.applyTheme(); // 组件创建时应用当前主题
    },
    methods: {
        // 切换主题
        toggleDarkMode() {
            this.theme = this.theme === 'dark' ? 'light' : 'dark';
            this.applyTheme();
        },
        // 应用主题：给 html 或 body 添加类名，同时更新 CSS 变量
        applyTheme() {
            const root = document.documentElement;
            if (this.theme === 'dark') {
                root.classList.add('dark');
            } else {
                root.classList.remove('dark');
            }
        },
    },
};
</script>

<style scoped>
.dark-mode-toggle {
    line-height: 20px;
    padding: 5px 15px;
    font-size: 16px;
    border: 1px solid var(--border-color, #ccc);
    border-radius: 20px;
    background: var(--bg-color, #fff);
    color: var(--text-color, #333);
    cursor: pointer;
    transition: all 0.3s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.dark-mode-toggle:hover {
    opacity: 0.8;
}
</style>